import type { Sport, RuleArticle } from '@proref/types';
import type { CreateSportInput, UpdateSportInput } from '@proref/schemas';
import { api, unwrap, type Envelope } from '../lib/api';

// The global sports catalogue (every authenticated role reads the same list).
export async function listSports(): Promise<Sport[]> {
  const res = await api.get<Envelope<Sport[]>>('/sports');
  return unwrap(res.data);
}

// Add a sport (super_admin only — the API enforces the role).
export async function createSport(input: CreateSportInput): Promise<Sport> {
  const res = await api.post<Envelope<Sport>>('/sports', input);
  return unwrap(res.data);
}

// Edit a sport (super_admin only). Addressed by id — the slug can change, so the id is the
// stable handle the PATCH route uses.
export async function updateSport(id: string, input: UpdateSportInput): Promise<Sport> {
  const res = await api.patch<Envelope<Sport>>(`/sports/${id}`, input);
  return unwrap(res.data);
}

// Delete a sport (super_admin only). The API refuses (409) if the sport still has clips/referees.
export async function deleteSport(id: string): Promise<void> {
  await api.delete<Envelope<null>>(`/sports/${id}`);
}

// The rule-book for one sport, addressed by slug.
export async function listRules(slug: string): Promise<RuleArticle[]> {
  const res = await api.get<Envelope<RuleArticle[]>>(`/sports/${slug}/rules`);
  return unwrap(res.data);
}
